import { render, staticRenderFns } from "./class_select.vue?vue&type=template&id=7106fcee&scoped=true&"
import script from "./class_select.vue?vue&type=script&lang=js&"
export * from "./class_select.vue?vue&type=script&lang=js&"
import style0 from "./class_select.vue?vue&type=style&index=0&id=7106fcee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106fcee",
  null
  
)

export default component.exports